/**
 * The queue rail.
 *
 * Eight queues in spec order, counts straight from `queue_counts` on the page response, so
 * the rail and the table are one derivation and cannot disagree. `exceptions` is a queue
 * the API can serve but not a chip here: an open exception is already a Needs attention
 * reason, and a rail with two doors onto the same problem is a rail where one of them is
 * always the wrong one.
 *
 * The number keys 1 to 8 are bound by the page, not here, because they must not fire while
 * the caret is in the search box.
 */
import type { OrderQueue } from '@elutide/shared';
import { QueueRail } from '@/components';
import { QUEUE_LABELS, RAIL_QUEUES } from './types';

export interface OrdersRailProps {
  counts: Partial<Record<OrderQueue, number>> | undefined;
  active: OrderQueue;
  onSelect: (queue: OrderQueue) => void;
}

export function OrdersRail({ counts, active, onSelect }: OrdersRailProps) {
  return (
    <QueueRail
      queues={RAIL_QUEUES.map((queue) => ({
        id: queue,
        label: QUEUE_LABELS[queue],
        count: counts?.[queue] ?? 0,
      }))}
      active={active}
      onSelect={onSelect}
    />
  );
}
